import { useNavigate } from 'react-router-dom';
import ContextSearchView from '../components/screens/ContextSearchView';
import useContextSearch from '../hooks/useContextSearch';

function ContextSearchPage({ auth }) {
  const navigate = useNavigate();
  const {
    question,
    searchResult,
    searchStatus,
    isSearching,
    setQuestion,
    submitSearch,
    buildNavigationPath,
  } = useContextSearch(auth.currentUser);

  const handleSubmitSearch = async (event) => {
    event.preventDefault();
    await submitSearch();
  };

  const handleOpenNavigationTarget = (target) => {
    const path = buildNavigationPath(target);
    if (!path) {
      return;
    }

    navigate(path);
  };

  return (
    <ContextSearchView
      question={question}
      searchResult={searchResult}
      searchStatus={searchStatus}
      isSearching={isSearching}
      onQuestionChange={setQuestion}
      onSubmitSearch={handleSubmitSearch}
      onOpenNavigationTarget={handleOpenNavigationTarget}
    />
  );
}

export default ContextSearchPage;
